export const moveEdgeInlet = (node, inletType, movingEdge) => {
    // first need to delete the current edge
   let toEffect = node.sequencerEngine.findNodeById(movingEdge.edge.destId);
    let fromEffect = node.sequencerEngine.findNodeById(movingEdge.edge.sourceId);

    if (toEffect && fromEffect) {
        toEffect.disconnectInlet(movingEdge.edge.destType, fromEffect, movingEdge.edge.sourceType);
    }
    node.connectInlet(inletType, fromEffect, movingEdge.sourceType);
};

export const moveEdgeOutlet = (node, outletType, movingEdge) => {
    // first need to delete the current edge
    let toEffect = node.sequencerEngine.findNodeById(movingEdge.edge.destId);
    let fromEffect = node.sequencerEngine.findNodeById(movingEdge.edge.sourceId);

    console.log("move edge outlet outletType=", outletType, fromEffect, toEffect);

    if (toEffect && fromEffect) {
        toEffect.disconnectInlet(movingEdge.edge.destType, fromEffect, movingEdge.edge.sourceType);
    }
    toEffect.connectInlet(movingEdge.edge.destType, node, outletType);
};

